import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppWrapper from "./AppWrapper";
import SingleAppWrapper from "./SingleAppWrapper";
import reportWebVitals from "./reportWebVitals";
import {
  NODE_ENV,
  IS_STANDALONE,
  BASEJUMP_API_URL,
  IS_PRODUCTION,
  SENTRY_DSN,
} from "./constants";

import * as Sentry from "@sentry/react";

const sentryEnvironment = IS_PRODUCTION
  ? "production"
  : NODE_ENV === "development"
    ? "development"
    : "staging";

Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  environment: sentryEnvironment,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: IS_PRODUCTION ? 0.1 : 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", BASEJUMP_API_URL],
});
Sentry.setTag("standalone", IS_STANDALONE);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {IS_STANDALONE ? <SingleAppWrapper /> : <AppWrapper />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
